<template>
  <Modal :value="isShow" class="hisModalBox" @on-cancel="cancelHandle" :mask-closable="true" class-name="vertical-center-modal">
    <span slot="header">原产地判定-历史版本({{dataSet.goodsName}}-{{dataSet.goodsPN}})</span>
    <div class="modal-content">
      <div class="modal-content-wrap">
        <Table :columns="query.columns" :data="query.list" no-data-text="暂无数据"></Table>
        <Page :total="query.total" :page-size="query.pageSize" size="small" @on-change="getQueryList" v-if="query.total > query.pageSize"></Page>
        <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import Loader from '@/components/layout/Loader'

export default {
  name: 'CooHistoryModal',
  components: { Loader },
  props: {
    isShow: {
      type: Boolean,
      default: false,
      required: false
    },
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      isShowLoader: false,
      query: {
        total: 0,
        pageSize: 5,
        columns: [
          {
            title: '判定时间',
            key: 'lastTime',
            align: 'center',
            className: 'tb_time',
            render: (h, params) => {
              return h('span', {style: {whiteSpace: 'nowrap'}}, [
                params.row.lastVersion === this.dataSet.lastVersion ? h('span', {style: {}}, '当前判定') : (params.row.lastTime || '-')
              ])
            }
          },
          {
            title: '判定结果',
            key: 'status',
            align: 'center',
            // width: 100,
            render: (h, params) => {
              return h('span', {
                style: { color: ['#bbb', '#00b55f'][parseInt(params.row.status)] }
              }, parseInt(params.row.status) === 1 ? '判定成功' : '判定失败')
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('div', {
                class: 'opr'
              }, [
                h('a', {
                  style: {color: '#1F8AFD'},
                  class: 'line2',
                  on: {
                    click: event => {
                      event.stopPropagation()
                      event.preventDefault()
                      // this.$parent.$parent.requestData(params.row.id)
                      this.$router.push({
                        name: 'RulesDecideVoteResult',
                        params: {id: params.row.id}
                      })
                      this.cancelHandle()
                    }
                  }
                }, '查看')
              ])
            }
          }
        ],
        list: []
      }
    }
  },
  watch: {
    dataSet (newVal, oldVal) {
      if (newVal && newVal.id) {
        this.getQueryList()
      }
    }
  },
  methods: {
    getQueryList (page = 1) {
      if (this.isShowLoader) return
      this.$Loading.start()
      this.isShowLoader = true
      this.$api.coo.determination.history(this.dataSet.goodsId, {page: page || 1, size: this.query.pageSize}, {
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.query.list = response.data.data.result || []
            this.query.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: errorMsg => {
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
          this.isShowLoader = false
        }
      })
    },
    cancelHandle () {
      this.$emit('changeState', false)
    }
  }
}
</script>
<style scoped>
  @media print,screen and (min-width:1366px) {
    .hisModalBox >>> .vertical-center-modal,
    .hisModalBox >>> .ivu-modal{
      width: 600px !important;
      margin: 0 auto;
    }
    .hisModalBox >>> .ivu-modal-close .ivu-icon-ios-close-empty{
      top: 0 !important;
    }
  }
  @media print,screen and (max-width:1365px) {
    .hisModalBox >>> .vertical-center-modal,
    .hisModalBox >>> .ivu-modal{
      width: 600px !important;
      margin: 0 auto;
    }
  }
  .hisModalBox >>> .loading .wrap{
    top: 36px;
  }
  .hisModalBox >>> .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -100px;
  }
  .hisModalBox >>> .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .hisModalBox >>> .ivu-modal-header{
    /*font-weight: bold;*/
    font-size: 15px;
  }
  /*.hisModalBox .ivu-modal-header,*/
  .hisModalBox >>> .ivu-modal-footer{
    display: none;
  }
  /*.hisModalBox .ivu-modal-close{*/
  /*display: none;*/
  /*}*/
  .hisModalBox >>> .ivu-table-wrapper{
    border: 0 none;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .hisModalBox >>> .ivu-table{
    color: #333;
  }
  .hisModalBox >>> .ivu-table th{
    background-color: #eaf7ff;
    font-size: 14px;
    font-weight: normal;
    border-color: #eaf7ff;
    font-weight: bold;
  }
  .hisModalBox >>> .ivu-table td{
    font-size: 15px;
    border-color: #F1F1F1;
  }
  .hisModalBox >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .hisModalBox >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .hisModalBox >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .hisModalBox >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .hisModalBox >>> .ivu-table-tip td{
    color: #999;
    font-size: 15px;
  }
  .hisModalBox >>> .ivu-page{
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
  }
  .hisModalBox >>> .ivu-page .ivu-page-item-active{
    background-color: #1F8AFD;
    border-color: #1F8AFD;
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/historyModal.vue